import React from 'react';
import { Typography } from '@material-ui/core';

export const PaymentCuotesEmty = () => (
  <Typography variant="caption" color="error">
    No podes pagar con este metodo de pago
  </Typography>
);
